import { MediaContainer } from '@spartacus/storefront';
import { BrandsEnum } from '@seb/web-design-system/core';
import { CmsComponent } from '@spartacus/core';

import { UppercaseBrandThemesEnum, UppercaseThemesEnum } from '../../enums';
import { CmsLinkDSComponentInterface } from '../cms-link-ds-component.model';
import { CustomMedia } from '../custom-media.model';
import { Wrapper } from '../wrapper.model';

export enum PushCardTextConfigEnum {
  LEFT = 'LEFT',
  CENTER = 'CENTER'
}

export enum PushCardMediaConfigEnum {
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
  RIGHT = 'RIGHT',
  LEFT = 'LEFT',
  BACKGROUND = 'BACKGROUND'
}

export enum PushCardImageRatioEnum {
  R1_1 = 'R1_1',
  R4_3 = 'R4_3',
  R16_9 = 'R16_9',
  R3_4 = 'R3_4',
  R21_9 = 'R21_9',
  R9_16 = 'R9_16',
  R9_21 = 'R9_21'
}

export enum PushCardSizeEnum {
  XXS = 'XXS',
  XS = 'XS',
  S = 'S',
  M = 'M',
  L = 'L'
}

export interface PushCardComponentInterface extends Wrapper {
  description?: string;
  footnote?: string;
  headline?: string;
  headlineLevel?: string;
  imageRatio?: PushCardImageRatioEnum;
  links?: string;
  linksObjects?: CmsLinkDSComponentInterface[];
  media?: CustomMedia;
  mediaConfig?: PushCardMediaConfigEnum;
  pictos?: Record<string, any>;
  pushSize?: PushCardSizeEnum;
  subline?: string;
  textConfig?: PushCardTextConfigEnum;
  theme?: UppercaseThemesEnum;
  isPushPromo?: string;
  mediaContainer?: MediaContainer;
  isDescription?: string;
  isFit?: string;
  hasModal?: string;
  indexFollow?: boolean;
  brandCorner?: BrandsEnum;
  tags?: string;
  tagsObjects?: CMSTagComponentInterface[];
  tooltipTitle?: string;
  tooltipDescription?: string;
  brand?: BrandsEnum;
  brandBar?: BrandsEnum;
  orderIndex?: number;
  trackingAction?: string;
}

export interface CMSTagComponentInterface extends CmsComponent {
  label?: string;
  theme?: UppercaseBrandThemesEnum;
}
